import styled from "styled-components"
import FormControl from 'react-bootstrap/lib/FormControl';
import Button from 'react-bootstrap/lib/Button';

const AddressContainer = styled.div.attrs(props => ({
  id: "address-pre-check"
}))`
  padding: 1rem 0rem;
  display: flex;
  flex: 1 1 auto;
`

const Row = styled.div`
  justify-content: center;
  display: flex;
`

const Title = styled.h1`
  #guest_signup>.container &&,
  #host_signup>.container && {
    font-size: 2.5rem;
    margin-top: 3rem;
  }
  color: #074165;
  font-family: 'Lato Black', sans-serif;
  letter-spacing: 0.8px;
`

const SubTitle = styled.h2`
  color: #7E95A1;
  font-family: 'Lato Light', sans-serif;
  letter-spacing: 0.4px;
  text-align: center;
  font-size: 2rem;
`

const Logo = styled.img`
  max-width: 190px;
  display: inline-block;
  &:last-child{
    padding-left: 3rem;
  }
`

const Search = styled(FormControl).attrs(props => ({
  id: 'addressSearch',
  type: "text",
  placeholder: "Search for your street address"
}))`
  margin-bottom: 3rem;
  padding: 1rem 1.8rem;
  height: 100%;
  border-color: #AFBBC4;
  &::placeholder {
    color: #AFBBC4;
  }
`

const Seperator = styled.hr`
  width: 100%;
  border-color: #D2DADF;
  margin: 3rem 0rem;
`

const Help = styled.h3`
  color: #074165;
  font-family: 'Lato', sans-serif;
  letter-spacing: 0.4px;
  text-align: center;
  font-size: 1.9rem;
  margin-bottom: 3rem;
`

const Submit = styled.button.attrs(props => ({
  className: "btn-info btn-fixed-width",
  type: "submit"
}))`
  && {
    background-color: #D8203E;
    border-color: #D8203E;
    border-radius: 9999px;
    display: block;
    margin: auto;
    padding: 0.7rem;
  }
  &&:hover {
    background-color: #D8203E;
    border-color: #D8203E;
  }
`

const Styles = {
  AddressContainer,
  Row,
  Title,
  SubTitle,
  Search,
  Help,
  Seperator,
  Submit,
  Logo,
}

export default Styles